<div class="container col-lg-12 mb-3">
    <div class="d-flex justify-content-between align-items-center">
        <h5 class="mb-0">Taxes et TVA</h5>
        <button class="btn btn-primary" (click)="addtax()">+ Ajouter</button>
    </div>
</div>
<div class="card-body p-0">
    <ul class="nav nav-tabs">
        <li class="nav-item">
            <a class="nav-link" [class.active]="activeTab === 'taxe'" (click)="check('taxe')" href="javascript:void(0)">Taxes</a>
        </li>
        <li class="nav-item">
            <a class="nav-link" [class.active]="activeTab === 'tva'" (click)="check('tva')" href="javascript:void(0)">Tva</a>
        </li>


  </ul>
  <div class="row text-nowrap">
    <div class="container p-0 m-0">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
